module.exports = __webpack_public_path__ + "img/check_circle_strong_green.cd16eb4a.svg";